window.PREBID_TIMEOUT = window.PREBID_TIMEOUT || 1500;

export default window.PREBID_TIMEOUT;
